export default __webpack_public_path__ + "static/media/AUTORES_DISCO_08.d1273a2b.png";